import React from "react";
import PropTypes from "prop-types";

export default function Expanded(props) {
  return (
    <svg
      onClick={props.onClick}
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 1C0 0.447715 0.447715 0 1 0H8.1875C8.73978 0 9.1875 0.447715 9.1875 1V7.66667C9.1875 8.21895 8.73979 8.66667 8.1875 8.66667H1C0.447716 8.66667 0 8.21895 0 7.66667V1Z"
        fill={props.fill}
      />
      <path
        d="M0 12.3333C0 11.781 0.447715 11.3333 1 11.3333H8.1875C8.73978 11.3333 9.1875 11.781 9.1875 12.3333V19C9.1875 19.5523 8.73979 20 8.1875 20H1C0.447716 20 0 19.5523 0 19V12.3333Z"
        fill={props.fill}
      />
      <path
        d="M11.8125 1C11.8125 0.447715 12.2602 0 12.8125 0H20C20.5523 0 21 0.447715 21 1V7.66667C21 8.21895 20.5523 8.66667 20 8.66667H12.8125C12.2602 8.66667 11.8125 8.21895 11.8125 7.66667V1Z"
        fill={props.fill}
      />
      <path
        d="M11.8125 12.3333C11.8125 11.781 12.2602 11.3333 12.8125 11.3333H20C20.5523 11.3333 21 11.781 21 12.3333V19C21 19.5523 20.5523 20 20 20H12.8125C12.2602 20 11.8125 19.5523 11.8125 19V12.3333Z"
        fill={props.fill}
      />
    </svg>
  );
}

Expanded.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  onClick: PropTypes.func
};
Expanded.defaultProps = {
  className: "",
  fill: "#C7CED9",
  width: 20,
  height: 21,
  onClick: () => null
};
